export default function BrandMark({ size = 40, dark = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <div
        className="grid place-items-center font-heading font-extrabold text-white rounded-sm"
        style={{ width: size, height: size, backgroundColor: "#EB1C27", fontSize: size * 0.42, letterSpacing: "-0.05em" }}
      >
        SK
      </div>
      <div className="leading-none">
        <div className={`font-heading font-extrabold tracking-tight ${dark ? "text-[#002B5D]" : "text-white"}`} style={{ fontSize: size * 0.42 }}>
          SK ZIPPERS
        </div>
        <div className={`text-[10px] font-mono uppercase tracking-[0.25em] mt-1 ${dark ? "text-slate-500" : "text-blue-200"}`}>
          Manufacturing Ops
        </div>
      </div>
    </div>
  );
}
